import {Component, Input, OnInit} from '@angular/core';
import {FormFieldBase} from '../form-field-base';
import {FormGroup} from '@angular/forms';

@Component({
  selector: 'qm-form-field',
  templateUrl: './form-field.component.html',
  styleUrls: ['./form-field.component.scss']
})
export class FormFieldComponent {

  @Input() field: FormFieldBase<any>;
  @Input() form: FormGroup;
  @Input() horizontal: boolean = false;
  @Input() titleWidth: number = 3;
  @Input() dataWidth: number = 9;

  public isValid() {
    if (this.form.controls[this.field.key]) {
      return this.form.controls[this.field.key].valid;
    } else {
      return true;
    }
  }

}
